import toast from "react-hot-toast";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";
import { findObjectUseCase } from "../../../../usecases/object";

export default class ManageClientFormPresenter extends BaseFormPresenter {
  // async inititalizeCreditObject(client) {
  //   // ADD CREDIT. DEFAULTS TO 0
  //   const creditObject = {
  //     balance: 0,
  //     client,
  //   };

  //   await this.upsertUseCase.execute("credits", creditObject);
  // }

  async inititalizeCreditObject(client) {
    // Check if credit already exists for this client
    const existingCredits = await findObjectUseCase().execute("credits", {
      where: {
        "client.id": client.id,
      },
    });

    console.log("existingCredits", existingCredits);

    if (existingCredits.length > 0) {
      console.log("Credit already exists for this client. Skipping creation.");
      return;
    }

    // ADD CREDIT. DEFAULTS TO 0
    const creditObject = {
      balance: 0,
      client,
    };

    console.log("creditObject", creditObject);

    await this.upsertUseCase.execute("credits", creditObject);
  }

  async save() {
    const collection = this.view.getCollectionName();
    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
      this.change.id = this.change.code;
      console.log("ths", this.change);
    }

    try {
      const newClient = await this.upsertUseCase.execute(
        collection,
        this.change,
      );
      await this.inititalizeCreditObject(newClient);

      this.change = {};
    } catch (error) {
      throw error;
    }
  }

  async submit() {
    if (Object.values(this.change).length === 0) {
      this.view.showSuccessSnackbar("Successfully saved!");
      return;
    }
    try {
      this.view.submitting();
      await this.view.showConfirmationDialog();
      await this.save();
      this.view.submissionSuccess();
      toast.success("Successfully saved!", { position: "top-right" });
      // this.view.navigateBack();
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}
